import {json2xml, xml2json} from 'xml-js';

const removeJsonTextAttribute = (value, parentElement) => {
    try {
        const parentOfParent = parentElement._parent;
        const pOpKeys = Object.keys(parentElement._parent);
        const keyNo = pOpKeys.length;
        const keyName = pOpKeys[keyNo - 1];
        const arrOfKey = parentElement._parent[keyName];
        const arrOfKeyLen = arrOfKey.length;
        if (arrOfKeyLen > 0) {
            const arr = arrOfKey;
            const arrIndex = arrOfKey.length - 1;
            arr[arrIndex] = value;
        } else {
            parentElement._parent[keyName] = value;
        }
    } catch (e) {
        console.log('error',e);
    }
};

function nativeType(value): any {
    const nValue = Number(value);
    if (!isNaN(nValue)) {
        return nValue;
    }
    const bValue = value.toLowerCase();
    if (bValue === 'true') {
        return true;
    } else if (bValue === 'false') {
        return false;
    }
    return value;
}


export class NICEStudioScriptBranch {
    // eslint-disable-next-line @typescript-eslint/ban-types
    Text: {};
    ActionID: string;
    Index: string;
    // eslint-disable-next-line @typescript-eslint/ban-types
    Segments: {};
}

export class NICEStudioScriptAction {
    ActionID: string;
    Action: string;
    Caption: string;
    Parameters: { string: string[]};
    Branches: {
        BranchStruct: NICEStudioScriptBranch[];
    };
    Cases: {
        BranchStruct: NICEStudioScriptBranch[];
    };
    X: number;
    Y: number;
    DependencyOrder: number;
    // tslint:disable-next-line:variable-name
    Impl_Type: string;
    LibraryID: string;
    ExtraInfo: {
        DefaultBranch: NICEStudioScriptBranch;
        Branches: {
            BranchStruct: NICEStudioScriptBranch[];
        };
        CaseBranches: {
            BranchStruct: NICEStudioScriptBranch[];
        };
    };
    DefaultNextAction: NICEStudioScriptBranch;
}

export class NICEStudioScriptData {
    _declaration: {
        _attributes: {
            version: string;
            encoding: string;
        };
    };
    ScriptContainer: {
        _attributes: {
            'xmlns:xsd': string;
            'xmlns:xsi': string;
            noNamespaceSchemaLocation: string;
            BusNo: string;
            UserID: string;
        };
        Actions: {
            ActionStruct: NICEStudioScriptAction[];
        };
        LibraryItem: {
            _attributes: {
                LibraryID: string;
                ApiClassificationId: string;
                BusNo: string;
                Name: string;
                Alias: string;
                MediaType: string;
                RouteOrder: string;
                VariableRedaction: string;
            };
            Icon: string;
            ImplPath: string;
            CreateDate: Date;
            ModifyDate: Date;
            ModifyUserID: string;
            ModifiedBy: string;
            URI: string;
            DefaultTimeZone: string;
            Parameters: {
                LibraryParam: [
                    {
                        Name: string;
                    }
                ];
            };
            // eslint-disable-next-line @typescript-eslint/ban-types
            Branches: {};
        };
        MediaType: string;
        ModifyDate: { _text: Date};
    };

    constructor(scriptBody?: string) {
        if (scriptBody) {
            const scriptXML = atob(scriptBody);
            const options = {
                compact: true,
                trim: true,
                ignoreDeclaration: false,
                ignoreInstruction: true,
                ignoreAttributes: false,
                ignoreComment: true,
                ignoreCdata: true,
                ignoreDoctype: true,
                spaces: 4,
                textFn: removeJsonTextAttribute
            };
            const result1 = xml2json(scriptXML, options);
            const jsonObject = JSON.parse(result1);
            if (jsonObject != null) {
                this._declaration = jsonObject._declaration;
                this.ScriptContainer = jsonObject.ScriptContainer;
            }
            if (jsonObject.ScriptContainer.Actions.ActionStruct) {
                if (jsonObject.ScriptContainer.Actions.ActionStruct.constructor !== Array)
                {
                    jsonObject.ScriptContainer.Actions.ActionStruct = [jsonObject.ScriptContainer.Actions.ActionStruct]
                }
                for (const action of jsonObject.ScriptContainer.Actions.ActionStruct) {
                    if (Object.keys(action.Parameters.string)?.length !== 0) {
                        let jsonSuff = JSON.stringify(action.Parameters.string);
                        if (!jsonSuff.substr(0, 1).includes('[')) {
                            jsonSuff = '[' + jsonSuff + ']';
                            const objstuf: string[] = JSON.parse(jsonSuff);
                            action.Parameters.string = objstuf;
                            //                       console.log(objstuf);
                        }
                        //                   console.log(action.Parameters.string);
                        action.Parameters.string.forEach((val, index) => {
                            if (Object.keys(action.Parameters.string[index]).length === 0) {
                                action.Parameters.string[index] = ''; // this removes the [object. Object] for null parameter items.

                            }
                        });
                    }

                }
                this.ScriptContainer.Actions.ActionStruct = jsonObject.ScriptContainer.Actions.ActionStruct;
            }
        } else {
            this._declaration = {
                _attributes: {
                    version: '1.0',
                    encoding: 'utf-8'
                }
            };
            this.ScriptContainer = {
                _attributes: {
                    ['xmlns:xsi']: 'http://www.w3.org/2001/XMLSchema-instance',
                    ['xmlns:xsd']: 'http://www.w3.org/2001/XMLSchema',
                    noNamespaceSchemaLocation: 'noNamespaceSchemaLocation',
                    BusNo: '1234',
                    UserID: '1234'
                },
                Actions: {
                    ActionStruct: [] as NICEStudioScriptAction[]
                },
                LibraryItem: {
                    _attributes: {
                        LibraryID: 'ce1a759e-48ff-46ea-b670-58632da57c2f',
                        ApiClassificationId: '0',
                        BusNo: '1234',
                        Name: 'New Skybox Script',
                        Alias: 'New Skybox Script',
                        MediaType: '4',
                        RouteOrder: '',
                        VariableRedaction: ''
                    },
                    Icon: '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',
                    ImplPath: 'New Skybox Script',
                    CreateDate: new Date(),
                    ModifyDate: new Date(),
                    ModifyUserID: '1234',
                    ModifiedBy: 'UserName',
                    URI: 'New Skybox Script',
                    DefaultTimeZone: 'Eastern Standard Time',
                    Parameters: {
                        LibraryParam: [
                            {
                                Name: ''
                            }
                        ]
                    },
                    Branches: {}
                },
                MediaType: '4',
                ModifyDate:
                    {
                        _text: new Date()
                    }
            };
        }
    }


    getXMLFile(): string {
        const options = {compact: true};
        return json2xml(JSON.stringify(this), options);
    }

    getScriptRecommendations(): NICEScriptRecommendation[] {
        const recommendations = [];
        if (this.ScriptContainer.Actions.ActionStruct) {
            for (const act of this.ScriptContainer.Actions.ActionStruct) {
                if (act.Action === 'BEGIN' && act.Caption !== this.ScriptContainer.LibraryItem._attributes.Name) {
                    const beginrec = new NICEScriptRecommendation();
                    beginrec.name = 'Proper Begin Caption';
                    beginrec.description = 'When tracing a script, it is best practice to label your Begin Action with the name of the script. \''
                        + this.ScriptContainer.LibraryItem._attributes.Name + '\'';
                    beginrec.isCompliant = false;
                    beginrec.nonCompliantActions = [act];
                    recommendations.push(beginrec);
                }
            }
        }
        // DefaultCaptionActions: NICEScriptRecommendation;
        // PlayNotDocumented: NICEScriptRecommendation;
        // RequestAgentNoWhisper: NICEScriptRecommendation;
        return recommendations;
    }

    fixBeginCaption(): void {
        for (const act of this.ScriptContainer.Actions.ActionStruct) {
            if (act.Action === 'BEGIN')
            {
                const re = /_PRD$|_DEV$|_PROD$|_QA$|_UAT$|_TEST$/;
                act.Caption = this.ScriptContainer.LibraryItem._attributes.Alias.replace(re,"").replace(/_/g," ");
                break;
            }
        }
    }

    insertAACScriptAuditAction()
    {
        this.removeAACScriptAuditAction();
        if (this.findActionID('BEGIN') !=='NotFound') {
            const beginAction = this.ScriptContainer.Actions.ActionStruct.filter((a) => a.Action === 'BEGIN')[0];
//            console.log('SCRIPT',this.ScriptContainer);
            const auditAction = new NICEStudioScriptAction();
            auditAction.ActionID = this.getNextActionID()
            auditAction.X = beginAction.X;
            auditAction.Y = Number(beginAction.Y) + 70;
            auditAction.Action = 'RUNSUB';
            auditAction.Parameters = {string: ['~\\SKYBOX_AAC_Script_Audit', '', 'RTN',this.ScriptContainer.LibraryItem.ImplPath]};
            auditAction.Caption = 'SKYBOX_AAC_Script_Audit';
            if ('DefaultNextAction' in beginAction && beginAction.DefaultNextAction != null) {
                auditAction.DefaultNextAction = {
                    ActionID: beginAction.DefaultNextAction.ActionID,
                    Index: "0",
                    Segments: {},
                    Text: {}
                };
            }
            beginAction.DefaultNextAction = {
                ActionID: auditAction.ActionID,
                Index: "0",
                Segments: {},
                Text: {}
            };
            this.ScriptContainer.Actions.ActionStruct.push(auditAction);
            this.updateAction(beginAction);
        }
    }

    removeAACScriptAuditAction()
    {
        let auditActionID = this.findActionID('RUNSUB','SKYBOX_AAC_Script_Usage');
        if (auditActionID !=='NotFound') {
            this.removeActionByID(auditActionID);
        }
        auditActionID = this.findActionID('RUNSUB','SKYBOX_AAC_Script_Audit');
        if (auditActionID !=='NotFound') {
            this.removeActionByID(auditActionID);
        }
    }

    findActionID(searchName:string, searchCaption?:string):string{
        if(this.ScriptContainer.Actions.ActionStruct) {
            for (const a of this.ScriptContainer.Actions.ActionStruct) {
                if (searchCaption) {
                    if (a.Action === searchName && a.Caption === searchCaption) {
                        return a.ActionID;
                    }
                } else {
                    if (a.Action === searchName) {
                        return a.ActionID;
                    }
                }

            }
        }
        return 'NotFound';
    }
    removeActionByID(removeId:string,): void{
        let actionIndex = 0
        let removeIndex = -1
        for (const a of this.ScriptContainer.Actions.ActionStruct){
            if (a.ActionID === removeId)
            {
                removeIndex = actionIndex;
                const auditNextAction = a.DefaultNextAction
                for (const b of this.ScriptContainer.Actions.ActionStruct){
                    if (b.DefaultNextAction && b.DefaultNextAction.ActionID === removeId)
                    {
                        b.DefaultNextAction = auditNextAction;
                    }
                }
                break
            }
            actionIndex++;
        }
        if(removeIndex >= 0 ) {
            this.ScriptContainer.Actions.ActionStruct.splice(removeIndex, 1);
        }
    }

    updateAction(updateAction:NICEStudioScriptAction):void
    {
        for (let a of this.ScriptContainer.Actions.ActionStruct){
            if (a.ActionID === updateAction.ActionID)
            {
                a = updateAction;
                break;
            }
        }
    }
    getNextActionID():string {
        return Math.max(...this.ScriptContainer.Actions.ActionStruct.map(o => Number(o.ActionID) + 1)).toString();
    }

}

export class NICEScriptRecommendation {
    name: string;
    description: string;
    isCompliant = true;
    nonCompliantActions: NICEStudioScriptAction[] = [];
}

